import ResponsivePhotoCapture from "./ResponsivePhotoCapture";
import type { IntakeData } from "@/lib/types";

interface PhotoCaptureStepProps {
  data: IntakeData;
  onUpdate: (data: Partial<IntakeData>) => void;
  onNext: () => void;
  onBack?: () => void;
}

export default function PhotoCaptureStep({
  data,
  onUpdate,
  onNext,
  onBack,
}: PhotoCaptureStepProps) {
  return (
    <ResponsivePhotoCapture
      data={data}
      onUpdate={onUpdate}
      onNext={onNext}
      onBack={onBack}
    />
  );
}
